import { Money } from '@betterment/core';
import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { nameAndImage } from '../sharedSchemas';

export const monthlyExpenses = Yup.object({
  monthlyExpensesAmount: Yup.string().required(),
});

const COVERAGE_OPTIONS = [3, 6, 9, 12, 'custom'] as const;

const coverage = Yup.object({
  targetAmount: Yup.mixed<Money>().required(),
  bufferPercentage: Yup.number().required(),
  monthsCovered: Yup.string().required(),
  selectedCoverage: Yup.mixed().oneOf(COVERAGE_OPTIONS).required(),
});

const coverageWithOption = (option: (typeof COVERAGE_OPTIONS)[number]) =>
  Yup.object({
    selectedCoverage: Yup.mixed().oneOf([option]).required(),
  });

const customCoverage = Yup.object({
  targetAmount: Yup.mixed<Money>().required(),
});

export const EMERGENCY_FUND_FLOW_CONFIG = createConfig({
  nameAndImage: {
    schema: nameAndImage,
    dependencies: Yup.object({}),
  },
  monthlyExpenses: {
    schema: monthlyExpenses,
    dependencies: Yup.object({
      nameAndImage,
    }),
  },
  coverage: {
    schema: coverage,
    dependencies: Yup.object({
      nameAndImage,
    }),
  },
  customCoverage: {
    schema: customCoverage,
    dependencies: Yup.object({
      coverage: coverageWithOption('custom'),
    }),
  },
});

export const { FlowProvider, useStep: useEmergencyFundStep } = createFlowContext(EMERGENCY_FUND_FLOW_CONFIG);

export const EmergencyFundFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
